<template>
  <article class="layout-section__container">
    <h3 class="layout-section__heading -spacing">Summer & Vacation</h3>

    <ul class="grid-icon">
      <li class="grid-icon__item">
        <svg-icon id="spring-flower" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="summer-drink" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="spring-sprout" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="spring-bee" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="spring-pops" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="spring-sun" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="summer-book" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="spring-bottle" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="mobile-home" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="spring-flower2" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="spring-leave" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="summer-hat" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="summer-tent" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="summer-flamingo" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="summer-swimming" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="summer-kayak" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="spring-clover" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="summer-sunscreen" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="spring-flower3" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="summer-boat" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="summer-sandal" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="summer-hamac" />
      </li>
    </ul>
  </article>
</template>

<script>
export default {
  name: 'WorkIconsSpring'
}
</script>
